<template>
    <Box :radius="isTablet ? 's' : 'none'" :padding="isTablet ? 'm' : 's'">
        <div class="checkout-section">
            <div v-if="slots.left" class="checkout-section-left">
                <slot name="left" />
            </div>
            <div v-if="slots.right" class="checkout-section-right">
                <slot name="right" />
            </div>
        </div>
    </Box>
</template>

<script lang="ts">
    import { defineComponent, useSlots } from 'vue';
    import { useScreenSize } from '@shared/helpers/viewport';
    import Box from '@ui/components/Box/Box.vue';

    export default defineComponent({
        name: 'Section',
        components: { Box },
        setup() {
            const slots = useSlots();
            const { isTablet } = useScreenSize();

            return {
                slots,
                isTablet,
            };
        },
    });
</script>

<style lang="scss">
    @forward 'Section.scss';
</style>
